import { render, staticRenderFns } from "./SendCouponEdit.vue?vue&type=template&id=67004eac&scoped=true&"
import script from "./SendCouponEdit.vue?vue&type=script&lang=js&"
export * from "./SendCouponEdit.vue?vue&type=script&lang=js&"
import style0 from "./SendCouponEdit.vue?vue&type=style&index=0&id=67004eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67004eac",
  null
  
)

export default component.exports